import { Modal } from '../components/Modal';
import { Button } from '../components/Button';

interface Props {
  onClose(): void;
}

export function ChangePasswordModal({ onClose }: Props): JSX.Element {
  return (
    <Modal onClose={onClose}>
      <div className="modal-hd">
        <div className="eb">Security</div>
        <div className="ttl">Change password</div>
      </div>
      <div className="modal-bd">
        <div>
          <label className="input-label">Current password</label>
          <input className="input" type="password" style={{ width: '100%' }} />
        </div>
        <div>
          <label className="input-label">New password</label>
          <input className="input" type="password" style={{ width: '100%' }} />
          <div className="d-meta" style={{ marginTop: 6, fontSize: 12 }}>At least 12 characters, with one number.</div>
        </div>
        <div>
          <label className="input-label">Confirm new password</label>
          <input className="input" type="password" style={{ width: '100%' }} />
        </div>
      </div>
      <div className="modal-foot">
        <Button variant="ghost" onClick={onClose}>Cancel</Button>
        <Button variant="primary">Save password</Button>
      </div>
    </Modal>
  );
}
